import React, { createContext, useContext } from 'react';

import clsx from 'clsx';
import { EmptyState, SigningStepsHeader, useTabStyles } from 'src/components';
import { WorkflowEmptyIcon } from 'src/components/icons/WorkflowEmptyIcon';
import { emailWithSubject } from 'src/helpers';
import { WorkflowBody } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

export const WorkflowReadyOnlyContext = createContext<boolean>(false);

export function useWorkflowReadOnlyContext(): { isReadOnly: boolean } {
  const isReadOnly = useContext(WorkflowReadyOnlyContext);
  return { isReadOnly };
}

interface WorkflowBuilderWorkflowProps {
  workflowId: UUID;
  isReadOnly?: boolean;
}

const useStyles = makeStyles()(theme => ({
  stepsTabContent: {
    gap: theme.spacing(2),
  },
}));

export function StepsTabContent({
  isReadOnly,
  workflowId,
}: WorkflowBuilderWorkflowProps): JSX.Element {
  const { classes } = useStyles();
  const { classes: tabClasses } = useTabStyles();

  return (
    <div className={clsx(tabClasses.tabContent, classes.stepsTabContent)}>
      <SigningStepsHeader workflowId={workflowId} />
      <WorkflowBuilderWorkflow isReadOnly={isReadOnly} workflowId={workflowId} />
    </div>
  );
}

const useBuilderStyles = makeStyles()(theme => ({
  builder: {
    boxSizing: 'border-box',
    padding: theme.spacing(4),
  },
}));

export function WorkflowBuilderWorkflow({
  isReadOnly = false,
  workflowId,
}: WorkflowBuilderWorkflowProps): JSX.Element {
  const { classes } = useBuilderStyles();

  return (
    <WorkflowReadyOnlyContext.Provider value={isReadOnly}>
      <WorkflowBody
        CannotViewWF={() => null}
        NoWorkflow={() => {
          return (
            <EmptyState
              buttonProps={{
                onClick: (): void => emailWithSubject({ newTab: true, subject: 'No workflow' }),
              }}
              buttonText="Contact Support"
              icon={<WorkflowEmptyIcon />}
              subtitle="Contact support to fix."
              title="No workflow"
            />
          );
        }}
        className={classes.builder}
        workflowId={workflowId}
      />
    </WorkflowReadyOnlyContext.Provider>
  );
}
